var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderReceipt',{attrs:{"header":"ดูรายละเอียดใบเสร็จ","img_header":_vm.header_image,"link_back":"stock/storage/addproducttostock"}}),_c('StoragePR_detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }